import { WeatherType } from '~/shared';

export const weatherLabels: Record<WeatherType, string> = {
	[WeatherType.EXTRASUNNY]: 'Очень солнечно',
	[WeatherType.CLEAR]: 'Ясно',
	[WeatherType.CLOUDS]: 'Облачно',
	[WeatherType.SMOG]: 'Смог',
	[WeatherType.FOG]: 'Туман',
	[WeatherType.OVERCAST]: 'Пасмурно',
	[WeatherType.RAIN]: 'Дождь',
	[WeatherType.THUNDER]: 'Гроза',
	[WeatherType.CLEARING]: 'Прояснение',
	[WeatherType.NEUTRAL]: 'Нейтрально',
	[WeatherType.SNOW]: 'Снег',
	[WeatherType.BLIZZARD]: 'Метель',
	[WeatherType.SNOWLIGHT]: 'Лёгкий снег',
	[WeatherType.XMAS]: 'Рождество',
	[WeatherType.HALLOWEEN]: 'Хеллоуин',
};
